import { Box } from '@mui/material'

interface ChargingSessionImageProps {
  src?: string
}

const ChargingSessionImage: React.FC<ChargingSessionImageProps> = ({
  src = '/assets/png/eletric-car-charging.png',
}) => {
  return (
    <Box
      component="img"
      src={src}
      width="100%"
      sx={{
        maxWidth: 200,
        userSelect: 'none',
        opacity: 0.5,
      }}
    />
  )
}

export default ChargingSessionImage
